import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { SeoProvider } from "@/lib/seo";
import WhatsAppFAB from "@/components/site/WhatsAppFAB";
import "@/index.css";

const App         = React.lazy(() => import("@/App"));
const Privacy     = React.lazy(() => import("@/pages/Privacy"));
const Terms       = React.lazy(() => import("@/pages/Terms"));
const AetherEIP   = React.lazy(() => import("@/pages/AetherEIP"));
const Opsora      = React.lazy(() => import("@/pages/Opsora"));
const FreshLoop   = React.lazy(() => import("@/pages/FreshLoop"));
const CostIQ      = React.lazy(() => import("@/pages/CostIQ"));
const NexusTel    = React.lazy(() => import("@/pages/NexusTel"));
const NexusOS     = React.lazy(() => import("@/pages/NexusOS"));
const Nodus       = React.lazy(() => import("@/pages/Nodus"));
const Solutions   = React.lazy(() => import("@/pages/Solutions"));
const IndustriesHub          = React.lazy(() => import("@/pages/industries/IndustriesHub"));
const IndOilAndGas           = React.lazy(() => import("@/pages/industries/OilAndGas"));
const IndManufacturing       = React.lazy(() => import("@/pages/industries/Manufacturing"));
const IndAutomotive          = React.lazy(() => import("@/pages/industries/Automotive"));
const IndTelecom             = React.lazy(() => import("@/pages/industries/Telecom"));
const IndRetailFmcg          = React.lazy(() => import("@/pages/industries/RetailFmcg"));
const IndEnergyUtility       = React.lazy(() => import("@/pages/industries/EnergyUtility"));
const IndElectricVehicles    = React.lazy(() => import("@/pages/industries/ElectricVehicles"));
const IndTransportationLog   = React.lazy(() => import("@/pages/industries/TransportationLogistics"));
const ServicesHub = React.lazy(() => import("@/pages/services/ServicesHub"));
const BusinessAutomation = React.lazy(() => import("@/pages/services/BusinessAutomation"));
const CustomSoftwareDev  = React.lazy(() => import("@/pages/services/CustomSoftwareDev"));
const AIIntegration      = React.lazy(() => import("@/pages/services/AIIntegration"));
const ERPSolutions       = React.lazy(() => import("@/pages/services/ERPSolutions"));
const Thanks             = React.lazy(() => import("@/pages/Thanks"));
const Contact            = React.lazy(() => import("@/pages/Contact"));
const AdminLogin         = React.lazy(() => import("@/pages/admin/AdminLogin"));
const AdminDashboard     = React.lazy(() => import("@/pages/admin/AdminDashboard"));
const AdminLeads         = React.lazy(() => import("@/pages/admin/AdminLeads"));

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <SeoProvider>
        <BrowserRouter>
          <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
            <Routes>
              <Route path="/" element={<App />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/solutions/aether-eip" element={<AetherEIP />} />
              <Route path="/solutions/opsora" element={<Opsora />} />
              <Route path="/solutions/freshloop" element={<FreshLoop />} />
              <Route path="/solutions/cost-iq" element={<CostIQ />} />
              <Route path="/solutions/nexustel" element={<NexusTel />} />
              <Route path="/solutions/nexusos" element={<NexusOS />} />
              <Route path="/solutions/nodus" element={<Nodus />} />
              <Route path="/industries" element={<IndustriesHub />} />
              <Route path="/industries/oil-and-gas" element={<IndOilAndGas />} />
              <Route path="/industries/manufacturing" element={<IndManufacturing />} />
              <Route path="/industries/automotive" element={<IndAutomotive />} />
              <Route path="/industries/telecom" element={<IndTelecom />} />
              <Route path="/industries/retail-fmcg" element={<IndRetailFmcg />} />
              <Route path="/industries/energy-utility" element={<IndEnergyUtility />} />
              <Route path="/industries/electric-vehicles" element={<IndElectricVehicles />} />
              <Route path="/industries/transportation-logistics" element={<IndTransportationLog />} />
              <Route path="/services" element={<ServicesHub />} />
              <Route path="/services/business-automation" element={<BusinessAutomation />} />
              <Route path="/services/custom-software-development" element={<CustomSoftwareDev />} />
              <Route path="/services/ai-integration" element={<AIIntegration />} />
              <Route path="/services/erp-solutions" element={<ERPSolutions />} />
              <Route path="/thanks" element={<Thanks />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/leads" element={<AdminLeads />} />
            </Routes>
          </Suspense>
          <WhatsAppFAB />
        </BrowserRouter>
      </SeoProvider>
    </HelmetProvider>
  </React.StrictMode>
);

const rootEl = document.getElementById("root");
// react-snap pre-renders the HTML at build time; hydrate that pre-rendered
// markup when it exists, otherwise mount normally for dev.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}
